module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/opengraph-image-70ac2a9904b05812194848d478e79079.jpg";